import React from "react";
import { DesignData } from "../Design&DevApproch/Design&DevData.jsx";

const Left = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
      {DesignData.map((x, i) => (
        <div
          key={i}
          className="relative flex flex-col sm:flex-row items-start sm:items-center border border-gray-300 bg-white rounded-md shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer p-5 sm:p-6 md:p-8"
        >
          {/* === Icon Section === */}
          <div className="relative flex-shrink-0 mb-4 sm:mb-0 sm:mr-5">
            <img
              src={x.backgroundImage}
              alt="bg-icon"
              className="w-[56px] h-[56px]"
            />
            <img
              src={x.image}
              alt={x.title}
              className="absolute top-[10px] left-[10px] w-[34px] h-[35px]"
            />
          </div>

          {/* === Text Section === */}
          <div className="text-left">
            <p className="text-[#1a202c] text-lg sm:text-xl font-semibold leading-7 mb-2">
              {x.title}
            </p>
            <p className="text-[14px] sm:text-[15px] text-[#4a5568] leading-[22px] sm:leading-[24px]">
              Unlike other companies, we are a{" "}
              <span className={x.color}>UX first</span> development company.
              Projects are driven by designers to ensure design and experiences
              translate seamlessly to code.
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Left;
